import TimelineFilterDialog from "../analysis/TimelineFilterDialog";

export default function PlaylistFilterDialog(props) {
    return <TimelineFilterDialog {...props} itemLabel="playlist" />;
}
